import { createRouter, createWebHistory } from "vue-router";
import routes from "./routes";
import store from "@/store";

// const router = createRouter({
//   history: createWebHistory(process.env.BASE_URL),
//   routes,
// });

// let router = {
//   routes,
// };

export const initializeRouter = () => {
  const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
  });

  router.beforeEach(async (to, from, next) => {
    let actualPath =
      to.path?.split("/").length >= 4
        ? to.path?.split("/")?.slice(2)?.join("/")
        : to.path;

    actualPath = actualPath[0] === "/" ? actualPath.slice(1) : actualPath;

    // Pegamos a última parte do caminho, que representa a tela
    const lastSegment = actualPath.split("/").pop();

    if (store.state.termo.aceite == false && to.name != "home") {
      next({ name: "home" });
      return;
    }

    to.meta && to.meta.label
      ? (document.title = `Multpex | ${to.meta.label}`)
      : (document.title = "Multpex");

    let modulos = [];

    if (
      to.matched[1].meta.label != "Página inicial" &&
      to.matched[1].meta.label != "styleguide" &&
      to.matched[1].meta.label != "acessoNegado" &&
      to.matched[1].meta.label != "403"
    ) {
      setTimeout(() => {
        if (store.state.autenticacao.modulos) {
          store.state.autenticacao.modulos.forEach((e) => {
            modulos.push(e.nome);
          });

          if (modulos.indexOf(to.matched[1].meta.label) == -1) {
            next({ name: "home" });
            return;
          }
        }
      }, 800);
    }

    if (
      (!store.state.autenticacao.usuarioLogado.menusLiberados.some(
        (menu) => menu.toLowerCase().includes(lastSegment.toLowerCase()) // Compara apenas o último segmento
      ) &&
        to.path != "/" &&
        actualPath != "/" &&
        to.path != "/sem-permissao" &&
        to.meta.permissioOnly != false &&
        Object.keys(to.params).length == 0 &&
        to.meta.show != false) ||
      (store.state.autenticacao.perfil == undefined &&
        store.state.autenticacao.perfil == null &&
        to.name != "home")
    ) {
      if (to.path === "/sem-permissao") {
        return next();
      } else {
        next({ path: "/sem-permissao", force: true, replace: true });
        return;
      }
    }

    next();
  });
  return router;
};

export default { initializeRouter };
